import { t } from '@ctcells/i18n'

import { Button } from '../atoms/Button.tsx'
import { ScreenState } from '../screens/ScreenState.tsx'

import { errorText } from './errorText.ts'

import './shell.css'

/**
 * 렌더 예외 한 덩이 — **경계 세 곳이 같은 얼굴을 쓴다**(화면 단 · 셸 단 · 최상위).
 * 갈리는 것은 「셸이 살아 있느냐」 하나뿐이라 그것만 `fatal` 로 받는다.
 *
 * 🔴 **예외 메시지 원문은 본문에 안 보인다.** 영문 스택은 사람이 할 일을 알려 주지 않는다 —
 *    접힌 `<details>` 안에만 둔다. 앱 5개가 전부 같은 모양이다(「개발일 때만」으로 가르지 않는다).
 */
export function ErrorView({
  error,
  fatal,
  onRetry,
  onHome,
}: {
  error: unknown
  /** 셸을 못 그린다 — 헤더도 작업 줄도 E-STOP 도 없다. 면 위에 세우고 문구를 바꾼다 */
  fatal?: boolean
  onRetry: () => void
  onHome: () => void
}) {
  const raw = errorText(error)

  return (
    <ScreenState
      actions={
        <>
          <Button onClick={onRetry} size="md" variant="primary">
            {t('app.retry')}
          </Button>
          {/* 🔴 앱마다 처음 화면이 다르다 — `/` 로만 보내고 각 앱의 루트가 알아서 넘긴다 */}
          <Button onClick={onHome} size="md">
            {t('app.home')}
          </Button>
        </>
      }
      {...(fatal === true ? { card: true } : {})}
      {...(raw === null
        ? {}
        : {
            detail: (
              <details className="placeholder__detail">
                <summary>{t('app.renderError.detail')}</summary>
                <pre className="placeholder__raw">{raw}</pre>
              </details>
            ),
          })}
      text={fatal === true ? t('app.renderError.fatalBody') : t('app.renderError.body')}
      title={t('app.renderError')}
      tone="error"
    />
  )
}
